import { render, staticRenderFns } from "./formerHeadmaster.vue?vue&type=template&id=b52b3fc4&scoped=true&"
import script from "./formerHeadmaster.vue?vue&type=script&lang=js&"
export * from "./formerHeadmaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52b3fc4",
  null
  
)

export default component.exports